<template>
  <div class="fob-compact-publication">
    <!-- ZEITSCHRIFTENARTIKEL -->
    <div v-if="type == 'artikel'">
      <div v-if="authors">{{authors}}</div>
      <div style="font-weight: bolder;">{{title}}</div>
      <div>
        <span v-if="journal" style="font-style: italic;">{{journal}}.</span>
        <span v-if="year">{{year}}.</span>
        <span v-if="band && journalNumber">
          {{band}}({{journalNumber}}).
        </span>
        <span v-if="seiteStart && seiteEnde">
          <span><translate>Publikation.compact.Abkuerzung.SeitePlural</translate>.</span>
          <span>{{seiteStart}}-{{seiteEnde}}</span>
        </span>
        <span v-else-if="seiteStart && !seiteEnde">
          <span><translate>Publikation.compact.Abkuerzung.Seite</translate>.</span>
          <span>{{seiteStart}}</span>
        </span>
      </div>
    </div>
    <!-- SAMMELBANDBEITRAG + BUCHBEITRAG + TAGUNGSBEITRAG -->
    <div v-else-if="['sammelbandbeitrag', 'buchbeitrag', 'tagungsbeitrag'].indexOf(type) !== -1">
      <div v-if="authors">{{authors}}</div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div v-if="herausgeber">
        <span>In:</span>
        <span>{{herausgeber}}</span>
      </div>
      <div>
        <span v-if="buchtitel" style="font-style: italic;">{{buchtitel}}.</span>
        <span v-if="verlagsort">{{verlagsort}}: </span>
        <span v-if="verleger">{{verleger}}. </span>
        <span v-if="year">{{year}}. </span>
        <span v-if="seiteStart && seiteEnde">
          <span><translate>Publikation.compact.Abkuerzung.SeitePlural</translate>.</span>
          <span>{{seiteStart}}-{{seiteEnde}}</span>
        </span>
        <span v-else-if="seiteStart && !seiteEnde">
          <span><translate>Publikation.compact.Abkuerzung.Seite</translate>.</span>
          <span>{{seiteStart}}</span>
        </span>
      </div>
    </div>
    <!-- MONOGRAPHIE -->
    <div v-else-if="type === 'monographie'">
      <div v-if="authors">{{authors}}</div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div>
        <span v-if="verlagsort">{{verlagsort}}:</span>
        <span v-if="verleger">{{verleger}}. </span><span v-if="year">{{year}}</span>
      </div>
    </div>
    <!-- SAMMELBAND -->
    <div v-else-if="type === 'sammelband'">
      <div v-if="herausgeber">
        <span>{{herausgeber}}</span>
      </div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div v-if="institution">
        <span>{{institution}}</span>
      </div>
      <div>
        <span v-if="verlagsort">{{verlagsort}}:</span>
        <span v-if="verleger">{{verleger}}. </span><span v-if="year">{{year}}</span>
      </div>
    </div>
    <!-- TAGUNGSBAND + QELLENEDITION + SONDERHEFT -->
    <div v-else-if="['tagungsband', 'quellenedition'].indexOf(type) !== -1">
      <div v-if="herausgeber">
        <span>{{herausgeber}}</span>
      </div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div v-if="institution">
        <span>{{institution}}</span>
      </div>
      <div>
        <span v-if="verlagsort">{{verlagsort}}:</span>
        <span v-if="verleger">{{verleger}}. </span>
        <span v-if="year">{{year}}</span>
      </div>
    </div>
    <!-- SONDERHEFT -->
    <div v-else-if="type === 'sonderheft'">
      <div v-if="herausgeber">
        <span>{{herausgeber}}</span>
      </div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div>
        <span v-if="journal" style="font-style: italic;">{{journal}}.</span>
        <span v-if="year">{{year}}.</span>
        <span v-if="band"> {{band}}</span>
        <span v-if="journalNumber"> ({{journalNumber}})</span>
      </div>
    </div>
    <!-- BERICHT + WORKINGPAPER -->
    <div v-else-if="['bericht', 'workingpaper'].indexOf(type) !== -1">
      <div v-if="authors">{{authors}}</div>
      <div v-else-if="herausgeber">{{herausgeber}}</div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div>
        <span v-if="institution">{{institution}}. </span>
        <span v-if="verlagsort">{{verlagsort}}. </span>
        <span v-if="year">{{year}}</span>
      </div>
    </div>
    <!-- DISSERTATION + HABILITATIONSSCHRIFT -->
    <div v-else-if="['dissertation', 'habilitationsschrift'].indexOf(type) !== -1">
      <div v-if="authors">{{authors}}</div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div>
        <span><translate>{{`Publikation.compact.${type}`}}</translate>. </span>
        <span v-if="institution">{{institution}}. </span>
        <span v-if="year">{{year}}</span>
      </div>
    </div>
    <!-- BEITRAGINNICHTWISSENSCHAFTLICHENMEDIEN -->
    <div v-else-if="type === 'beitraginnichtwissenschaftlichenmedien'">
      <div v-if="authors">{{authors}}</div>
      <div v-else-if="herausgeber">{{herausgeber}}</div>
      <div style="font-weight: bolder;">
        <span>{{title}}</span>
      </div>
      <div>
        <span v-if="journal" style="font-style: italic;">{{journal}}. </span>
        <span v-if="year">{{year}}</span>
      </div>
    </div>
    <!-- SONSTIGE -->
    <div v-else>
      <div v-if="authors">{{authors}}</div>
      <div v-else-if="herausgeber">{{herausgeber}}</div>
      <div>
        <span style="font-weight: bolder;">{{title}}</span>
        <span v-if="year"> ({{year}})</span>
      </div>
    </div>
    <!-- generic information -->
    <div v-if="doi.id || isbn.id" class="fob-publikation-compact-link">
      <span v-if="doi.id">DOI: <a :href="doi.uri" target="_blank" rel="noopener noreferrer">{{doi.id}}</a></span>
      <span v-if="!doi.id && isbn.id">ISBN: <a :href="isbn.uri" target="_blank" rel="noopener noreferrer">{{isbn.id}}</a></span>
    </div>
  </div>
</template>

<script>

import CompactViewHelper from '@/components/mixins/CompactViewHelper'

export default {
  name: 'fob-publikation-compact',
  mixins: [CompactViewHelper],
  props: ['schema', 'data'],
  computed: {
    authors () {
      let authors = this.data.author.map(this.shortNameWithIntial)

      if (authors.length > 15) {
        return `${authors.slice(0, 3).join('; ')} et al.`
      } else {
        return authors.join('; ')
      }
    },
    buchtitel () {
      return this.data.buchtitel
    },
    journal () {
      return this.data.journal
    },
    journalNumber () {
      return this.data.journalNummer
    },
    band () {
      return this.data.band
    },
    doi () {
      let doi = this.data.publicPubIdent.filter(pubIdent => pubIdent.pubIdentTyp.kennung === 'DOI')[0]
      let id = doi && doi.wert || ''
      let uri = encodeURI(`https://doi.org/${id}`)

      return { id, uri }
    },
    herausgeber () {
      let herausgeber = this.data.herausgeber.map(this.shortNameWithIntial)

      // if no editor is set, then set the institution as editor
      if (herausgeber && herausgeber.length === 0) {
        herausgeber = this.institution ? [this.institution] : []
      }

      if (herausgeber.length === 1) {
        return `${herausgeber.join('; ')} (${this.$gettext('Publikation.compact.Abkuerzung.Herausgeber')}.)`
      } else if (herausgeber.length > 1) {
        return `${herausgeber.join('; ')} (${this.$gettext('Publikation.compact.Abkuerzung.HerausgeberPlural')}.)`
      } else {
        return ''
      }
    },
    institution () {
      return this.data.institution
    },
    isbn () {
      let isbn = this.data.publicPubIdent.filter(pubIdent => pubIdent.pubIdentTyp.kennung === 'ISBN')[0]
      let id = isbn && isbn.wert || ''
      let uri = encodeURI(`https://www.worldcat.org/isbn/${id}`)

      return { id, uri }
    },
    seiteEnde () {
      return this.data.seiteEnde
    },
    seiteStart () {
      return this.data.seiteStart
    },
    title () {
      return this.data.titelPublikation
    },
    type () {
      return this.data.publikationsTyp.toLowerCase()
    },
    verlagsort () {
      return this.data.verlagsort
    },
    verleger () {
      return this.data.verleger
    },
    year () {
      return this.data.veroeffentlichungsJahr
    }
  }
}
</script>

<style lang="scss">
  .fob-publication-compact-type {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/compact/Publikation.vue